export const THREE_D_VIEW_LAYOUT = {
  scene: {
    camera: {
      up: {
        x: 0,
        y: 0,
        z: 1,
      },
      center: {
        x: 0,
        y: 0,
        z: 0,
      },
      eye: {
        x: -2.75,
        y: -2.75,
        z: 2.75,
      },
    },
    hovermode: false,
    autosize: false,
    xaxis: {
      title: {
        text: "a*",
      },
      nticks: 5,
      range: [-110, 110],
      backgroundcolor: "rgb(255, 255, 255)",
      gridcolor: "rgb(220, 220, 220)",
    },
    yaxis: {
      title: {
        text: "b*",
      },
      nticks: 5,
      range: [-110, 110],
      backgroundcolor: "rgb(255, 255, 255)",
      gridcolor: "rgb(220, 220, 220)",
    },
    zaxis: {
      title: {
        text: "L*",
      },
      nticks: 5,
      range: [0, 100],
      backgroundcolor: "rgb(255, 255, 255)",
      gridcolor: "rgb(220, 220, 220)",
    },
  },
  margin: {
    r: 0,
    l: 0,
    b: 0,
    t: 0,
  },
  width: 280,
  height: 350, // Increase the height of the plot area
  showlegend: false,
};

export const RESET_THREE_D_VIEW_LAYOUT = {
  scene: {
    camera: {
      up: {
        x: 0,
        y: 0,
        z: 1,
      },
      center: {
        x: 0,
        y: 0,
        z: 0,
      },
      eye: {
        x: -2.76,
        y: -2.76,
        z: 2.76,
      },
    },
    autosize: false,
    hovermode: false,
    xaxis: {
      title: {
        text: "a*",
      },
      nticks: 5,
      range: [-110, 110],
      backgroundcolor: "rgb(255, 255, 255)",
      gridcolor: "rgb(220, 220, 220)",
    },
    yaxis: {
      title: {
        text: "b*",
      },
      nticks: 5,
      range: [-110, 110],
      backgroundcolor: "rgb(255, 255, 255)",
      gridcolor: "rgb(220, 220, 220)",
    },
    zaxis: {
      title: {
        text: "L*",
      },
      nticks: 5,
      range: [0, 100],
      backgroundcolor: "rgb(255, 255, 255)",
      gridcolor: "rgb(220, 220, 220)",
    },
  },
  margin: {
    r: 0,
    l: 0,
    b: 0,
    t: 0,
  },
  width: 280,
  height: 350, // Increase the height of the plot area
  showlegend: false,
};

export const TOP_VIEW_LAYOUT = {
  scene: {
    aspectmode: "cube",
    annotations: [
      {
        showarrow: false,
        text: "-100",
        x: -100.0,
        y: -100.0,
        yshift: -12,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "-60",
        x: -60.0,
        y: -100.0,
        yshift: -12,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "-20",
        x: -20.0,
        y: -100.0,
        yshift: -12,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "20",
        x: 20.0,
        y: -100.0,
        yshift: -12,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "60",
        x: 60.0,
        y: -100.0,
        yshift: -12,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "100",
        x: 100.0,
        y: -100.0,
        yshift: -12,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "-100",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "-60",
        x: -100.0,
        xshift: -15,
        y: -60.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "-20",
        x: -100.0,
        xshift: -15,
        y: -20.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "20",
        x: -100.0,
        xshift: -15,
        y: 20.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "60",
        x: -100.0,
        xshift: -15,
        y: 60.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "100",
        x: -100.0,
        xshift: -15,
        y: 100.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "a*",
        x: 0.0,
        y: -100.0,
        yshift: -25,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "b*",
        x: -100.0,
        xshift: -30,
        y: 0.0,
        z: 100.0,
      },
    ],
    camera: {
      up: {
        x: 0,
        y: 1,
        z: 0,
      },
      eye: {
        x: 0,
        y: 0,
        z: 3.45,
      },
    },
    hovermode: false,
    xaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [-110, 110],
    },
    yaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [-110, 110],
    },
    zaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [0, 100],
    },
    dragmode: false,
  },
  // shapes: [
  //   {
  //     type: "line",
  //     x0: 0.13,
  //     y0: 0.25,
  //     x1: 100,
  //     y1: 0,
  //     line: {
  //       color: "rgb(68, 68, 68)",
  //       width: 0.5,
  //     },
  //   },
  //   {
  //     type: "line",
  //     x0: 0.13,
  //     y0: 0.25,
  //     x1: 0.13,
  //     y1: 0.8,
  //     line: {
  //       color: "rgb(68, 68, 68)",
  //       width: 0.5,
  //     },
  //   },
  // ],
  margin: {
    r: 10,
    l: 10,
    b: 10,
    t: 10,
  },
  width: 350,
  height: 350, // Make width and height equal for 1:1 aspect ratio
  showlegend: false,
};

export const RED_GREEN_VIEW_LAYOUT = {
  scene: {
    annotations: [
      {
        showarrow: false,
        text: "-100",
        x: -100.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "-60",
        x: -60.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "-20",
        x: -20.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "20",
        x: 20.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "60",
        x: 60.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "100",
        x: 100.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "0",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "20",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 20.0,
      },
      {
        showarrow: false,
        text: "40",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 40.0,
      },
      {
        showarrow: false,
        text: "60",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 60.0,
      },
      {
        showarrow: false,
        text: "80",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 80.0,
      },
      {
        showarrow: false,
        text: "100",
        x: -100.0,
        xshift: -15,
        y: -100.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "a*",
        x: 0.0,
        y: -100.0,
        yshift: -25,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "L*",
        x: -100.0,
        xshift: -30,
        y: -100.0,
        z: 50.0,
      },
    ],
    camera: {
      eye: {
        x: 0,
        y: -3.45,
        z: 0,
      },
    },
    hovermode: false,
    xaxis: {
      title: "", // Remove Y-axis title (label)
      showticklabels: false, // Hide tick labels on Y-axis
      visible: false,
      linecolor: "black", // Color of the y-axis line
      nticks: 5,
      range: [-110, 110],
    },
    yaxis: {
      title: {
        text: "",
      },
      showline: true, // Make the y-axis line visible
      linecolor: "black", // Color of the y-axis line
      visible: false,
      nticks: 5,
      range: [-110, 110],
    },
    zaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [0, 100],
    },
    dragmode: false,
  },
  // shapes: [
  //   {
  //     type: "line",
  //     x0: 0.19, // WIDTH OF X AXIS FROM LEFT
  //     y0: 0.36, // HEIGHT FROM BOTTOM OF LINE
  //     x1: 50, // DIRECTION OF X AXIS FROM
  //     y1: 0.01,
  //     line: {
  //       color: "rgb(68, 68, 68)",
  //       width: 0.5,
  //     },
  //   },
  //   {
  //     type: "line",
  //     x0: 0.19, // LEFT PADDING TOP
  //     y0: 0.36, // HEIGHT OF VERTICAL LINE FROM BOTTOM
  //     x1: 0.19, // LEFT PADDING BOTTOM
  //     y1: 0.7, // HEIGHT OF Y AXIS
  //     line: {
  //       color: "rgb(68, 68, 68)",
  //       width: 0.5,
  //     },
  //   },
  // ],
  margin: {
    r: 0,
    l: 0,
    b: 0,
    t: 0,
  },
  width: 280,
  height: 350, // Increase the height of the plot area
  showlegend: false,
};

export const YELLOW_BLUE_VIEW_LAYOUT = {
  scene: {
    annotations: [
      {
        showarrow: false,
        text: "-100",
        x: 100.0,
        y: -100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "-60",
        x: 100.0,
        y: -60.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "-20",
        x: 100.0,
        y: -20.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "20",
        x: 100.0,
        y: 20.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "60",
        x: 100.0,
        y: 60.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "100",
        x: 100.0,
        y: 100.0,
        yshift: -12,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "0",
        x: 100.0,
        xshift: -15,
        y: -100.0,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "20",
        x: 100.0,
        xshift: -15,
        y: -100.0,
        z: 20.0,
      },
      {
        showarrow: false,
        text: "40",
        x: 100.0,
        xshift: -15,
        y: -100.0,
        z: 40.0,
      },
      {
        showarrow: false,
        text: "60",
        x: 100.0,
        xshift: -15,
        y: -100.0,
        z: 60.0,
      },
      {
        showarrow: false,
        text: "80",
        x: 100.0,
        xshift: -15,
        y: -100.0,
        z: 80.0,
      },
      {
        showarrow: false,
        text: "100",
        x: 100.0,
        xshift: -15,
        y: -100.0,
        z: 100.0,
      },
      {
        showarrow: false,
        text: "b*",
        x: 100.0,
        y: 0.0,
        yshift: -25,
        z: 0.0,
      },
      {
        showarrow: false,
        text: "L*",
        x: 100.0,
        xshift: -30,
        y: -100.0,
        z: 50.0,
      },
    ],
    camera: {
      eye: {
        x: 3.45,
        y: 0,
        z: 0,
      },
    },
    hovermode: false,
    xaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [-110, 110],
    },
    yaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [-110, 110],
    },
    zaxis: {
      title: {
        text: "",
      },
      visible: false,
      nticks: 5,
      range: [0, 100],
    },
    dragmode: false,
  },
  // shapes: [
  //   {
  //     type: "line",
  //     x0: 0.1, // WIDTH OF X AXIS FROM LEFT
  //     y0: 0.36, // HEIGHT FROM BOTTOM OF LINE
  //     x1: 50, // DIRECTION OF X AXIS FROM
  //     y1: 0.07,
  //     line: {
  //       color: "rgb(68, 68, 68)",
  //       width: 0.5,
  //     },
  //   },
  //   {
  //     type: "line",
  //     x0: 0.1, // LEFT PADDING TOP
  //     y0: 0.36, // HEIGHT OF VERTICAL LINE FROM BOTTOM
  //     x1: 0.1, // LEFT PADDING BOTTOM
  //     y1: 0.7, // HEIGHT OF Y AXIS
  //     line: {
  //       color: "rgb(68, 68, 68)",
  //       width: 0.5,
  //     },
  //   },
  // ],
  margin: {
    r: 0,
    l: 60,
    b: 0,
    t: 0,
  },
  width: 280,
  height: 350, // Increase the height of the plot area
  showlegend: false,
};

export const CONFIG = {
  displayModeBar: false, // Hides the entire modebar
  plotGlPixelRatio: Math.max(window.devicePixelRatio || 1, 2), // Force at least 2x rendering for sharp quality
};
